import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import reservationHistoryActions from "../../../redux/reservationHistory/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import DatePickerComponent from "../../../components/Common/DatePicker/DatePicker";
import ReservationHistoryTable from "../../../components/User/ReservationHistoryComponents/ReservationHistoryTable";
import { useProjectState } from "../../../context/stateContext";

import "./index.css";

const { getReservationsHistory } = reservationHistoryActions;

const ReservationHistory = () => {
  const { startDate, endDate } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getReservationsHistory({
        organizationId: localStorage.getItem("organizationId"),
        StartDate: startDate,
        EndDate: endDate,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <>
      <PageHeader text="Справка на резервациите" date={true} />
      <div className="reservation-history-date-picker-container">
        <DatePickerComponent />
      </div>
      <ReservationHistoryTable />
    </>
  );
};

export default ReservationHistory;
